
import { defineComponent } from "vue";
export default defineComponent({
  methods: {
    returnIndex() {
      this.$router.push("/");
    },
  },
  setup() {
    return {};
  },
});
